var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCampaign(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.66671 9.33425L3.71647 13.5333C3.746 13.6514 3.76076 13.7104 3.77822 13.762C3.94882 14.2657 4.40239 14.6198 4.93239 14.6631C4.98664 14.6676 5.04751 14.6676 5.16924 14.6676C5.32167 14.6676 5.39788 14.6676 5.46209 14.6614C6.0967 14.5998 6.59893 14.0976 6.66048 13.463C6.66671 13.3988 6.66671 13.3225 6.66671 13.1701V3.66758M12.3334 9.00092C13.622 9.00092 14.6667 7.95625 14.6667 6.66758C14.6667 5.37892 13.622 4.33425 12.3334 4.33425M6.83337 3.66758H4.33337C2.67652 3.66758 1.33337 5.01073 1.33337 6.66759C1.33338 8.32444 2.67652 9.66758 4.33337 9.66758H6.83338C8.01099 9.66758 9.45154 10.2988 10.5629 10.9047C11.2113 11.2581 11.5354 11.4348 11.7478 11.4088C11.9446 11.3847 12.0935 11.2963 12.2089 11.135C12.3334 10.961 12.3334 10.6129 12.3334 9.91673V3.41844C12.3334 2.72225 12.3334 2.37415 12.2089 2.20018C12.0935 2.03885 11.9446 1.95045 11.7478 1.92634C11.5354 1.90033 11.2113 2.07705 10.5629 2.43049C9.45154 3.03633 8.01099 3.66758 6.83337 3.66758Z",
    stroke: "#000D26",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCampaign);
export default __webpack_public_path__ + "static/media/campaign.410a71d44f2c769ff133db8b0e3ffb13.svg";
export { ForwardRef as ReactComponent };